import { useSyncExternalStore } from "react";

import { getSessionSnapshot, type SessionSnapshot, subscribeSession } from "./session";

export function useSession(): SessionSnapshot {
    return useSyncExternalStore(subscribeSession, getSessionSnapshot);
}
